// Import Istanbul Tourist Pass Images
import istanbulLogin from "../assets/projects/istanbulTouristPass/login-ios.png";
import istanbulHome from "../assets/projects/istanbulTouristPass/home-ios.png";
import istanbulActivities from "../assets/projects/istanbulTouristPass/activities-ios.png";
import istanbulMyActivities from "../assets/projects/istanbulTouristPass/myActivities-ios.png";
import istanbulOffers from "../assets/projects/istanbulTouristPass/offers-ios.png";
import istanbulGalata from "../assets/projects/istanbulTouristPass/galata-ios.png";
import istanbulDolmabahce from "../assets/projects/istanbulTouristPass/dolmabahce-ios.png";
import istanbulHagia from "../assets/projects/istanbulTouristPass/hagia.png";
import istanbulHagiaDetay from "../assets/projects/istanbulTouristPass/hagiaDetay.png";
import istanbulBeykoz from "../assets/projects/istanbulTouristPass/beykoz-ios.png";
import istanbulBeykozRes from "../assets/projects/istanbulTouristPass/beykozReserved.png";
import istanbulDetayMap2 from "../assets/projects/istanbulTouristPass/detayMap-2.png";
import istanbulFavorites from "../assets/projects/istanbulTouristPass/favorites-ios.png";
import istanbulHome2 from "../assets/projects/istanbulTouristPass/home-2.png";
import istanbulOptions from "../assets/projects/istanbulTouristPass/options.png";
import istanbulSlot from "../assets/projects/istanbulTouristPass/slot.png";
import istanbulSlot2 from "../assets/projects/istanbulTouristPass/slot-2.png";
import istanbulQR from "../assets/projects/istanbulTouristPass/qr.png";
import istanbulPayment from "../assets/projects/istanbulTouristPass/payment.png";
import istanbulAI from "../assets/projects/istanbulTouristPass/aiChat.png";
import istanbulAfisYatay from "../assets/projects/istanbulTouristPass/afisYatay.png";

// Import Law Project Images
import law1 from "../assets/projects/law/law1.PNG";
import law2 from "../assets/projects/law/law2.PNG";
import law3 from "../assets/projects/law/law3.PNG";
import law4 from "../assets/projects/law/law4.PNG";
import law5 from "../assets/projects/law/law5.PNG";
import law6 from "../assets/projects/law/law6.PNG";
import law7 from "../assets/projects/law/law7.PNG";
import law9 from "../assets/projects/law/law9.PNG";
import law10 from "../assets/projects/law/law10.PNG";
import law11 from "../assets/projects/law/law11.PNG";
import law12 from "../assets/projects/law/law12.PNG";
import law13 from "../assets/projects/law/law13.PNG";
import React, { useState, useEffect } from "react";
import { FaApple, FaGooglePlay, FaGlobe, FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Import PropertyManager Diagrams
import DatabaseDiagram from "../assets/projects/PropertyManager/Diagrams/DatabaseDiagram.jpg";
import FlowChartDiagram_base from "../assets/projects/PropertyManager/Diagrams/FlowChartDiagram_base.jpg";
import FlowChartDiagram_indetail from "../assets/projects/PropertyManager/Diagrams/FlowChartDiagram_indetail.jpg";
import RelationshipBetwwenTables from "../assets/projects/PropertyManager/Diagrams/RelationshipBetwwenTables.png";
import UseCaseDiagram from "../assets/projects/PropertyManager/Diagrams/UseCaseDiagram.jpg";
import UsedTechnologies from "../assets/projects/PropertyManager/Diagrams/technologies.PNG";

// Import PropertyManager Screen Images
import addEmployeeImage from "../assets/projects/PropertyManager/addEmployeeImage.png";
import callingImg from "../assets/projects/PropertyManager/callingImg.png";
import callManagerImg from "../assets/projects/PropertyManager/callManagerImg.png";
import deleteBtnImage from "../assets/projects/PropertyManager/deleteBtnImage.png";
import editBtnImage from "../assets/projects/PropertyManager/editBtnImage.png";
// import editEmployeeImage from "../assets/projects/PropertyManager/editEmployeeImage.png"; // Removed unused import
import employeeImage from "../assets/projects/PropertyManager/employeeImage.png";
import homeImage from "../assets/projects/PropertyManager/homeImage.png";
import loginImage from "../assets/projects/PropertyManager/loginImage.png";
import makeManagerImg from "../assets/projects/PropertyManager/makeManagerImg.png";
import sideMenuImage from "../assets/projects/PropertyManager/sideMenuImage.png";
import signupImage from "../assets/projects/PropertyManager/signupImage.png";

// Import Shopistire Images
import shopistire_2 from "../assets/projects/shopistire/2025-08-05 (2).png";
import shopistire_6 from "../assets/projects/shopistire/2025-08-05 (6).png";
import shopistire_8 from "../assets/projects/shopistire/2025-08-05 (8).png";
import shopistire_9 from "../assets/projects/shopistire/2025-08-05 (9).png";
import shopistire_12 from "../assets/projects/shopistire/2025-08-05 (12).png";
// import shopistire_14 from "../assets/projects/shopistire/2025-08-05 (14).png"; // Removed unused import
import shopistire_15 from "../assets/projects/shopistire/2025-08-05 (15).png";
import shopistire_16 from "../assets/projects/shopistire/2025-08-05 (16).png";
import shopistire_17 from "../assets/projects/shopistire/2025-08-05 (17).png";
// import shopistire_18 from "../assets/projects/shopistire/2025-08-05 (18).png"; // Removed unused import
import shopistire_19 from "../assets/projects/shopistire/2025-08-05 (19).png";
// import shopistire_20 from "../assets/projects/shopistire/2025-08-05 (20).png"; // Removed unused import
import shopistire_21 from "../assets/projects/shopistire/2025-08-05 (21).png";
import shopistire_22 from "../assets/projects/shopistire/2025-08-05 (22).png";
import shopistire_23 from "../assets/projects/shopistire/2025-08-05 (23).png";
import shopistire_24 from "../assets/projects/shopistire/2025-08-05 (24).png";
import shopistire_25 from "../assets/projects/shopistire/2025-08-05 (25).png";
import shopistire_26 from "../assets/projects/shopistire/2025-08-05 (26).png";
import shopistire_28 from "../assets/projects/shopistire/2025-08-05 (28).png";
import shopistire_29 from "../assets/projects/shopistire/2025-08-05 (29).png";
import shopistire_33 from "../assets/projects/shopistire/2025-08-05 (33).png";
import shopistire_34 from "../assets/projects/shopistire/2025-08-05 (34).png";
import mobilHome from "../assets/projects/shopistire/mobilHome.PNG";
import mobilLogin from "../assets/projects/shopistire/mobilLogin.PNG";
import mobilNav from "../assets/projects/shopistire/mobilNav.PNG";
import mobilSepet from "../assets/projects/shopistire/mobilSepet.PNG";
import mobilSepetLight from "../assets/projects/shopistire/mobilSepetLight.PNG";
import mobilUrun from "../assets/projects/shopistire/mobilUrun.PNG";
import mobilUrunLight from "../assets/projects/shopistire/mobilUrunLight.PNG";

// Import Maglo Images
import maglo1 from "../assets/projects/Maglo/maglo1.PNG";
import maglo2 from "../assets/projects/Maglo/maglo2.PNG";
import maglo3 from "../assets/projects/Maglo/maglo3.PNG";
import maglo4 from "../assets/projects/Maglo/maglo4.PNG";
import maglo5 from "../assets/projects/Maglo/maglo5.PNG";
import maglo7 from "../assets/projects/Maglo/maglo7.PNG";
import maglo8 from "../assets/projects/Maglo/maglo8.PNG";
import maglo9 from "../assets/projects/Maglo/maglo9.PNG";
import maglo10 from "../assets/projects/Maglo/maglo10.PNG";

// Import Beauty Center Images
import beautyCenterSS from "../assets/projects/beautyCenter/WebScreens/ss.PNG";
import beautyCenterSS2 from "../assets/projects/beautyCenter/WebScreens/ss2.PNG";
import beautyCenterSS3 from "../assets/projects/beautyCenter/WebScreens/ss3.PNG";
import beautyCenterSS4 from "../assets/projects/beautyCenter/WebScreens/ss4.PNG";
import beautyCenterSS5 from "../assets/projects/beautyCenter/WebScreens/ss5.PNG";
import beautyCenterSS6 from "../assets/projects/beautyCenter/WebScreens/ss6.PNG";
import beautyCenterSS7 from "../assets/projects/beautyCenter/WebScreens/ss7.PNG";
import beautyCenterSS8 from "../assets/projects/beautyCenter/WebScreens/ss8.PNG";
import beautyCenterSS9 from "../assets/projects/beautyCenter/WebScreens/ss9.PNG";
import beautyCenterSS10 from "../assets/projects/beautyCenter/WebScreens/ss10.PNG";
import beautyCenterSS11 from "../assets/projects/beautyCenter/WebScreens/ss11.PNG";
import beautyCenterMobile11 from "../assets/projects/beautyCenter/mobileScreens/ss11.PNG";
import beautyCenterMobile12 from "../assets/projects/beautyCenter/mobileScreens/ss12.PNG";
import beautyCenterMobile13 from "../assets/projects/beautyCenter/mobileScreens/ss13.PNG";
import beautyCenterMobile14 from "../assets/projects/beautyCenter/mobileScreens/ss14.PNG";
import beautyCenterMobile15 from "../assets/projects/beautyCenter/mobileScreens/ss15.PNG";
import beautyCenterMobile16 from "../assets/projects/beautyCenter/mobileScreens/ss16.PNG";
import beautyCenterMobile17 from "../assets/projects/beautyCenter/mobileScreens/ss17.PNG";
import beautyCenterMobile18 from "../assets/projects/beautyCenter/mobileScreens/ss18.PNG";
import beautyCenterMobile19 from "../assets/projects/beautyCenter/mobileScreens/ss19.PNG";
import beautyCenterMobile20 from "../assets/projects/beautyCenter/mobileScreens/ss20.PNG";
import beautyCenterMobile21 from "../assets/projects/beautyCenter/mobileScreens/ss21.PNG";
import beautyCenterMobile22 from "../assets/projects/beautyCenter/mobileScreens/ss22.PNG";
import beautyCenterMobile23 from "../assets/projects/beautyCenter/mobileScreens/ss23.PNG";

// Import Diver (Anemon Turizm) Images
import diverDesktopDarkHome from "../assets/projects/diver/desktop-dark-home.png";
import diverDesktopDarkServicesCards from "../assets/projects/diver/desktop-dark-services-cards.png";
import diverDesktopDarkWhyUs from "../assets/projects/diver/desktop-dark-why-us.png";
import diverDesktopDarkCtaFooter from "../assets/projects/diver/desktop-dark-cta-footer.png";
import diverDesktopDarkAbout from "../assets/projects/diver/desktop-dark-about.png";
import diverDesktopDarkValues from "../assets/projects/diver/desktop-dark-values.png";
import diverDesktopDarkContact from "../assets/projects/diver/desktop-dark-contact.png";
import diverDesktopLightHome from "../assets/projects/diver/desktop-light-home.png";
import diverDesktopLightServicesCards from "../assets/projects/diver/desktop-light-services-cards.png";
import diverDesktopLightWhyUs from "../assets/projects/diver/desktop-light-why-us.png";
import diverDesktopLightCtaFooter from "../assets/projects/diver/desktop-light-cta-footer.png";
import diverDesktopLightServicesPage from "../assets/projects/diver/desktop-light-services-page.png";
import diverDesktopLightAboutLanguageMenu from "../assets/projects/diver/desktop-light-about-language-menu.png";
import diverMobileDarkHome from "../assets/projects/diver/mobile-dark-home.png";
import diverMobileDarkServicesPage from "../assets/projects/diver/mobile-dark-services-page.png";
import diverMobileDarkServicesCaveDive from "../assets/projects/diver/mobile-dark-services-cave-dive.png";
import diverMobileLightHome from "../assets/projects/diver/mobile-light-home.png";
import diverMobileLightServicesPage from "../assets/projects/diver/mobile-light-services-page.png";
import diverMobileLightContact from "../assets/projects/diver/mobile-light-contact.png";

// Other project imports
import gunnerHit from "../assets/projects/GunnerHit/gunnergit.png";
import islandRun from "../assets/projects/IslandRun/IslandRun.png";
// import { data } from "autoprefixer"; // Removed unused import

function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openProjectModal = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const openImageModal = (img, title, idx) => {
    setSelectedImage({ img, title, idx });
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const navigateImage = (direction) => {
    if (!selectedImage || !selectedProject) return;
    
    const totalImages = selectedProject.allImages.length;
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (selectedImage.idx + 1) % totalImages;
    } else {
      newIndex = (selectedImage.idx - 1 + totalImages) % totalImages;
    }
    
    const newImage = selectedProject.allImages[newIndex];
    setSelectedImage({ 
      img: newImage.src, 
      title: selectedProject.title, 
      idx: newIndex 
    });
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const closeModal = () => {
    setSelectedImage(null);
    setSelectedProject(null);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const closeProjectModal = () => {
    setSelectedProject(null);
  };

  // const handleZoomIn = () => {
  //   setZoom((prev) => Math.min(prev + 0.25, 5));
  // }; // Removed unused function

  // const handleZoomOut = () => {
  //   setZoom((prev) => Math.max(prev - 0.25, 0.25));
  // }; // Removed unused function

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.1 : 0.1;
    setZoom((prev) => Math.max(0.25, Math.min(5, prev + delta)));
  };

  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && zoom > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // const resetZoom = () => {
  //   setZoom(1);
  //   setPosition({ x: 0, y: 0 });
  // }; // Removed unused function

  // ESC tuşu ile modal'ı kapatma ve Arrow keys ile navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Escape" && (selectedImage || selectedProject)) {
        closeModal();
      }
      if (selectedImage && selectedProject) {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          navigateImage('next');
        }
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          navigateImage('prev');
        }
      }
    };

    if (selectedImage || selectedProject) {
      document.addEventListener("keydown", handleKeyPress);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
      document.body.style.overflow = "unset";
    };
  }, [selectedImage, selectedProject]);

  // Static project data
  const staticProjects = [
    {
      id: "diver-tour",
      title: "Diving Tour Operator Website",
      description: (
        <>
          A modern, multilingual website for Anemon Turizm, a TURSAB-licensed
          diving tour operator offering PADI courses and dive trips worldwide.
          Built with Next.js, it showcases dive experiences such
          as Discover Dive, Waterfall Dive, Wreck Dive and Cave Dive, and
          includes an about page, a contact form and a call-to-action flow.
          <ul className="list-disc ml-6 mt-2">
            <li>4-language support: Turkish, English, German and Russian</li>
            <li>
              WhatsApp integration: every tour's reservation button opens a
              chat with a tour-specific pre-filled message
            </li>
            <li>Dark and light mode</li>
            <li>Fully responsive design for desktop and mobile</li>
          </ul>
        </>
      ),
      mainImage: diverDesktopLightHome,
      technologies: [
        "Next.js",
        "i18n (TR/EN/DE/RU)",
        "WhatsApp Integration",
        "Dark/Light Mode",
        "Responsive Design",
      ],
      allImages: [
        { type: "desktop", src: diverDesktopDarkHome },
        { type: "desktop", src: diverDesktopDarkServicesCards },
        { type: "desktop", src: diverDesktopDarkWhyUs },
        { type: "desktop", src: diverDesktopDarkCtaFooter },
        { type: "desktop", src: diverDesktopDarkAbout },
        { type: "desktop", src: diverDesktopDarkValues },
        { type: "desktop", src: diverDesktopDarkContact },
        { type: "desktop", src: diverDesktopLightHome },
        { type: "desktop", src: diverDesktopLightServicesCards },
        { type: "desktop", src: diverDesktopLightWhyUs },
        { type: "desktop", src: diverDesktopLightCtaFooter },
        { type: "desktop", src: diverDesktopLightServicesPage },
        { type: "desktop", src: diverDesktopLightAboutLanguageMenu },
        { type: "mobile", src: diverMobileDarkHome },
        { type: "mobile", src: diverMobileDarkServicesPage },
        { type: "mobile", src: diverMobileDarkServicesCaveDive },
        { type: "mobile", src: diverMobileLightHome },
        { type: "mobile", src: diverMobileLightServicesPage },
        { type: "mobile", src: diverMobileLightContact },
      ],
    },
    {
      id: "istanbul-tourist-pass",
      title: "Istanbul Tourist Pass - Mobile App",
      description: (
        <>
          A production-ready mobile application for{" "}
          <a
            href="https://istanbultouristpass.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
          >
            Istanbul Tourist Pass
          </a>{" "}
          customers to manage their purchased services and discover new experiences.
          <br />
          <br />
          I led the complete development cycle from architecture planning to production deployment. This included App Store and Play Store release management, version migration strategies, customer-focused update releases, and performance optimization based on user analytics. I resolved critical issues such as native module compatibility across different device generations, layout adaptation for non-standard screen sizes, and network resilience for poor connectivity scenarios.
          <br />
          <br />
          Built with Expo framework to maintain a unified codebase across web, iOS, and Android platforms. I implemented platform-specific solutions where needed. For example, integrating Stripe payment gateway with conditional rendering (React for web, React Native for mobile). I actively tracked Expo's latest features and leveraged expo-updates for OTA (Over-The-Air) deployments, enabling rapid bug fixes and feature rollouts without requiring app store review cycles after establishing the core architecture.
          <br />
          <br />
          <div className="flex flex-wrap gap-3 mt-2">
            <a
              href="https://apps.apple.com/tr/app/istanbul-tourist-pass/id6535683117"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-white dark:bg-black text-black dark:text-white rounded-lg hover:bg-gray-100 dark:hover:bg-gray-900 transition-all duration-200 border border-gray-300 dark:border-gray-700"
            >
              <FaApple className="text-2xl" />
              <div className="flex flex-col items-start leading-tight">
                <span className="text-[9px] font-normal">Download on the</span>
                <span className="text-sm font-semibold -mt-0.5">App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.istanbultouristpass.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-white dark:bg-black text-black dark:text-white rounded-lg hover:bg-gray-100 dark:hover:bg-gray-900 transition-all duration-200 border border-gray-300 dark:border-gray-700"
            >
              <FaGooglePlay className="text-xl" />
              <div className="flex flex-col items-start leading-tight">
                <span className="text-[9px] font-normal">GET IT ON</span>
                <span className="text-sm font-semibold -mt-0.5">Google Play</span>
              </div>
            </a>
            <a
              href="https://app.istanbultouristpass.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-white dark:bg-black text-black dark:text-white rounded-lg hover:bg-gray-100 dark:hover:bg-gray-900 transition-all duration-200 border border-gray-300 dark:border-gray-700"
            >
              <FaGlobe className="text-xl" />
              <div className="flex flex-col items-start leading-tight">
                <span className="text-[9px] font-normal">OPEN IN</span>
                <span className="text-sm font-semibold -mt-0.5">Web App</span>
              </div>
            </a>
          </div>
        </>
      ),
      mainImage: istanbulAfisYatay,
      technologies: [
        "Expo",
        "TypeScript",
        "Payment Systems (Stripe)",
        "AI Integration",
        "Sentry",
        "QR Code",
        "Booking System",
        "iOS & Android",
        "Web App",
      ],
      allImages: [
        { type: "mobile", src: istanbulLogin },
        { type: "mobile", src: istanbulHome },
        { type: "mobile", src: istanbulHome2 },
        { type: "mobile", src: istanbulActivities },
        { type: "mobile", src: istanbulMyActivities },
        { type: "mobile", src: istanbulFavorites },
        { type: "mobile", src: istanbulOffers },
        { type: "mobile", src: istanbulGalata },
        { type: "mobile", src: istanbulDolmabahce },
        { type: "mobile", src: istanbulHagia },
        { type: "mobile", src: istanbulHagiaDetay },
        { type: "mobile", src: istanbulBeykoz },
        { type: "mobile", src: istanbulBeykozRes },
        { type: "mobile", src: istanbulDetayMap2 },
        { type: "mobile", src: istanbulOptions },
        { type: "mobile", src: istanbulSlot },
        { type: "mobile", src: istanbulSlot2 },
        { type: "mobile", src: istanbulPayment },
        { type: "mobile", src: istanbulQR },
        { type: "mobile", src: istanbulAI },
      ],
    },
    {
      id: "beauty-salon",
      title: "Beauty Salon Website",
      description: (
        <>
          A clean and reusable beauty salon website template built with Next.js
          and TypeScript. The entire website content can be managed from a
          single siteConfig file, making it easy to customize for different
          businesses. It includes SEO optimization, LocalBusiness schema,
          WhatsApp integration, and a fully responsive design. No backend or
          database is required. <br />
          <a
            href="https://beautyliva.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            beautyliva.com
          </a>
        </>
      ),
      mainImage: beautyCenterSS,
      technologies: [
        "Next.js",
        "TypeScript",
        "Tailwind CSS",
        "Responsive Design",
      ],
      allImages: [
        ...[
          beautyCenterSS,
          beautyCenterSS2,
          beautyCenterSS3,
          beautyCenterSS4,
          beautyCenterSS5,
          beautyCenterSS6,
          beautyCenterSS7,
          beautyCenterSS8,
          beautyCenterSS9,
          beautyCenterSS10,
          beautyCenterSS11,
        ].map((img) => ({ type: "desktop", src: img })),
        ...[
          beautyCenterMobile11,
          beautyCenterMobile12,
          beautyCenterMobile13,
          beautyCenterMobile14,
          beautyCenterMobile15,
          beautyCenterMobile16,
          beautyCenterMobile17,
          beautyCenterMobile18,
          beautyCenterMobile19,
          beautyCenterMobile20,
          beautyCenterMobile21,
          beautyCenterMobile22,
          beautyCenterMobile23,
        ].map((img) => ({ type: "mobile", src: img })),
      ],
    },
    {
      id: "law-firm",
      title: "Law Firm Website",
      description: (
        <>
          A modern and professional website template designed for Turkish law
          firms. Built with Next.js and TypeScript, it features a
          mobile-responsive layout, SEO optimization, and single-file content
          management. All content can be easily updated from{" "}
          <code>config/site.ts</code>.<br />
          <ul className="list-disc ml-6 mt-2">
            <li>Modern and professional design</li>
            <li>Mobile responsive</li>
            <li>SEO & social media optimization</li>
            <li>Turkish language support</li>
            <li>Single-file content management</li>
          </ul>
          <br />
          <a
            href="https://www.yilmazkayahukuk.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            yilmazkayahukuk.com
          </a>
        </>
      ),
      mainImage: law1,
      technologies: [
        "Next.js",
        "TypeScript",
        "Tailwind CSS",
        "SEO",
        "Responsive Design",
      ],
      allImages: [
        law1,
        law2,
        law3,
        law4,
        law5,
        law6,
        law7,
        law9,
        law10,
        law11,
        law12,
        law13,
      ].map((img) => ({ type: "desktop", src: img })),
    },
    {
      id: "shopistire",
      title: "Shopistire E-Commerce Platform",
      description: (
        <>
          A responsive e-commerce web app built with React and Redux. Users can
          browse, filter, and manage products easily on both desktop and mobile
          devices. Redux ensures smooth global state management. It supports
          both dark and light mode. <br />
          <a
            href="https://shopistire.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            shopistire.com
          </a>
        </>
      ),
      mainImage: shopistire_2,
      technologies: ["React", "Redux Toolkit", "CSS3"],
      allImages: [
        ...[
          shopistire_12,
          shopistire_6,
          shopistire_26,
          shopistire_15,
          shopistire_16,
          shopistire_17,
          shopistire_19,
          shopistire_9,
          shopistire_8,
          shopistire_28,
          shopistire_29,

          shopistire_2,
          shopistire_21,
          shopistire_25,
          shopistire_23,
          shopistire_22,
          shopistire_24,
          shopistire_33,
          shopistire_34,
        ].map((img) => ({ type: "desktop", src: img })),
        ...[
          mobilHome,
          mobilLogin,
          mobilUrun,
          mobilSepet,
          mobilNav,

          mobilUrunLight,
          mobilSepetLight,
        ].map((img) => ({ type: "mobile", src: img })),
      ],
    },
    {
      id: "maglo",
      title: "Data Analytics Dashboard",
      description:
        "A web application developed with modern UI/UX principles, based on Figma design (pixel-perfect). Data from the API is listed visually in the dashboard with charts.  Features include user authentication, interactive interface, and responsive design optimized for mobile screens.",
      mainImage: maglo1,
      technologies: [
        "React",
        "Tailwind CSS",
        "JavaScript",
        "Zustand",
        "Vite",
        "Responsive Design",
      ],
      allImages: [
        ...[maglo1, maglo2, maglo3, maglo4].map((img) => ({
          type: "desktop",
          src: img,
        })),
        ...[maglo5, maglo7, maglo8, maglo9, maglo10].map((img) => ({
          type: "mobile",
          src: img,
        })),
      ],
    },
    {
      id: "property-management",
      title: "Property Management Software",
      description:
        "A mobile app that helps people living in a site (residential complex) communicate better and makes management tasks easier. Residents can quickly find contact details for the manager. Managers can easily add, view, edit, and remove residents, admins, and employees. The app gives fast access to important information and lets managers manage everything directly from their phone.",
      mainImage: DatabaseDiagram,
      technologies: ["React Native", "Asp.NET Core", "MSSQL"],
      allImages: [
        ...[
          UsedTechnologies,
          FlowChartDiagram_base,
          FlowChartDiagram_indetail,
          DatabaseDiagram,
          RelationshipBetwwenTables,
          UseCaseDiagram,
        ].map((img) => ({ type: "diagram", src: img })),
        ...[
          loginImage,
          signupImage,
          homeImage,
          sideMenuImage,
          employeeImage,
          deleteBtnImage,
          editBtnImage,
          addEmployeeImage,
          makeManagerImg,
          callManagerImg,
          callingImg,
        ].map((img) => ({ type: "mobile", src: img })),
      ],
    },
    {
      id: "gunner-hit",
      title: "Gunner Hit Game",
      description: "A Unity-based action game.",
      mainImage: gunnerHit,
      technologies: ["Unity", "C#"],
      allImages: [{ type: "screen", src: gunnerHit }],
    },
    // {
    //   id: "island-run",
    //   title: "Island Run Game",
    //   description: "A Unity-based endless runner game.",
    //   mainImage: islandRun,
    //   technologies: ["Unity", "C#"],
    //   allImages: [{ type: "screen", src: islandRun }],
    // },
  ];

  return (
    <section
      id="projects"
      className="py-16 bg-white dark:bg-black text-gray-600 dark:text-gray-300 px-10 p-10 rounded-xl mt-10 transition-colors duration-300"
    >
      <h2 className="text-4xl text-center mb-8 text-gray-700 dark:text-gray-200">
        Projects
      </h2>
      <hr className="h-px my-8 bg-gray-400 dark:bg-gray-500 border-0" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
        {staticProjects.map((project) => (
          <div
            key={project.id}
            className="bg-gray-50 dark:bg-[#111112] rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
            onClick={() => openProjectModal(project)}
          >
            <div className="relative overflow-hidden">
              <img
                src={project.mainImage}
                alt={project.title}
                className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300"></div>
            </div>

            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 dark:text-gray-200 mb-3 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors">
                {project.title}
              </h3>

              <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 line-clamp-3">
                {typeof project.description === "string"
                  ? project.description
                  : project.description.props.children[0]}
              </p>

              <div className="flex flex-wrap gap-2 mb-4">
                {project.technologies.slice(0, 3).map((tech, techIndex) => (
                  <span
                    key={techIndex}
                    className="px-3 py-1 bg-purple-100 dark:bg-purple-800 text-purple-700 dark:text-purple-200 rounded-full text-xs font-medium"
                  >
                    {tech}
                  </span>
                ))}
                {project.technologies.length > 3 && (
                  <span className="px-3 py-1 bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-full text-xs">
                    +{project.technologies.length - 3} more
                  </span>
                )}
              </div>

              <div className="text-purple-600 dark:text-purple-400 text-sm font-medium">
                View {project.allImages.length} images →
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeProjectModal}
        >
          <div
            className="bg-white dark:bg-gray-900 rounded-lg max-w-6xl w-full max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex justify-between items-center p-6 border-b dark:border-gray-700">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200">
                  {selectedProject.title}
                </h2>
                <div className="flex flex-wrap gap-2 mt-2">
                  {selectedProject.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-purple-100 dark:bg-purple-800 text-purple-700 dark:text-purple-200 rounded-full text-sm font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
              <button
                onClick={closeProjectModal}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-3xl font-bold p-2"
              >
                ×
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
              <div className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
                {selectedProject.description}
              </div>

              {/* Images Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {selectedProject.allImages.map((imageObj, idx) => (
                  <div key={idx} className="relative group">
                    <img
                      src={imageObj.src}
                      alt={`${selectedProject.title} ${imageObj.type} ${
                        idx + 1
                      }`}
                      className={`w-full h-48 rounded-lg cursor-pointer hover:scale-105 transition-transform duration-300 shadow-md ${
                        imageObj.type === "mobile"
                          ? "object-contain bg-gray-100 dark:bg-gray-800"
                          : "object-cover"
                      }`}
                      onClick={() =>
                        openImageModal(imageObj.src, selectedProject.title, idx)
                      }
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
                      {imageObj.type}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-8"
          onClick={closeImageModal}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            {/* Close button */}
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 bg-white dark:bg-gray-800 text-black dark:text-white rounded-full w-12 h-12 flex items-center justify-center text-2xl font-bold hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors z-10 shadow-lg leading-none pb-1"
            >
              ×
            </button>

            {/* Previous button */}
            {selectedProject && selectedProject.allImages.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigateImage('prev');
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white dark:bg-gray-800 text-black dark:text-white rounded-full w-12 h-12 flex items-center justify-center text-2xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors z-10 shadow-lg"
              >
                <FaChevronLeft />
              </button>
            )}

            {/* Next button */}
            {selectedProject && selectedProject.allImages.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigateImage('next');
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white dark:bg-gray-800 text-black dark:text-white rounded-full w-12 h-12 flex items-center justify-center text-2xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors z-10 shadow-lg"
              >
                <FaChevronRight />
              </button>
            )}

            {/* Image counter */}
            {selectedProject && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-full text-sm z-10">
                {selectedImage.idx + 1} / {selectedProject.allImages.length}
              </div>
            )}

            {/* Image Container */}
            <div
              className="w-full h-full flex items-center justify-center p-16 overflow-hidden"
              onWheel={handleWheel}
            >
              <img
                src={selectedImage.img}
                alt={`${selectedImage.title} screenshot ${
                  selectedImage.idx + 1
                }`}
                className="rounded-lg shadow-2xl transition-transform duration-200"
                style={{
                  maxWidth: zoom === 1 ? "100%" : "none",
                  maxHeight: zoom === 1 ? "100%" : "none",
                  width: zoom === 1 ? "auto" : `${zoom * 100}%`,
                  height: zoom === 1 ? "auto" : "auto",
                  objectFit: "contain",
                  transform:
                    zoom > 1
                      ? `translate(${position.x}px, ${position.y}px)`
                      : "none",
                  cursor:
                    zoom > 1 ? (isDragging ? "grabbing" : "grab") : "default",
                }}
                onMouseDown={handleMouseDown}
                onClick={(e) => e.stopPropagation()}
                draggable={false}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Projects;
